// Dependencies

// Styles
require("./fiche-masonry-1-2.scss");
var $ = require('jquery');
$grid = $("[data-isotope-grid]");
$filters = $("[data-isotope-filters]");

if ($grid.length && $filters.length) {

    require("isotope-layout");

    $grid.isotope({
        itemSelector: '.fiche-masonry-1-2__item',
        layoutMode: 'fitRows'
    });
}


//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/fiche-masonry-1/view-2/index.js
// module id = 191
// module chunks = 0